// extracted by mini-css-extract-plugin
module.exports = {"login":"Login_login__2ft7b","button":"Login_button__1Rusk"};